import {} from 'components'
import { CoreCapsuleWithAccount } from 'entities'
import { useResponsive } from 'hooks'
import { formatBigNumber } from 'utils'
import { IInfoItemProps } from './InfoItem'
import { InfoItemsBundle } from './InfoItemsBundle'

export interface ITopStatsProps {
  coreCapsule: CoreCapsuleWithAccount
}

export const TopStats = ({ coreCapsule }: ITopStatsProps) => {
  const { width } = useResponsive()
  const isMobile = width < 800

  const creditLimitAttributes = coreCapsule.creditLimitAttributes
  const scoreThreshold = creditLimitAttributes?.threshold || '0'

  const maxLtvRounded = Number(formatBigNumber(coreCapsule.maxLTV.mul(100), 2)).toFixed(0)

  const ltv = `Up to ${maxLtvRounded}% LTV`
  const tvl = `$${formatBigNumber(coreCapsule?.totalValueLocked)}`

  const infoItems: IInfoItemProps[] = [
    {
      label: 'Score threshold',
      tooltip: 'The minimum score required to borrow this vault',
      value: `${scoreThreshold}+`,
    },
    {
      label: 'Capital efficiency',
      tooltip: 'The maximum LTV ratio on this vault given a 999 credit score',
      value: ltv,
    },
    {
      label: 'Total value locked',
      tooltip: 'The $USD value of collateral locked in the vault',
      value: tvl,
    },
  ]

  return <InfoItemsBundle isMobile={isMobile} items={infoItems} />
}
